module.exports = __webpack_public_path__ + "assets/man.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/man.svg
// module id = 1180
// module chunks = 7